import { Box, Grid, GridItem } from '@chakra-ui/react';
import React from 'react';

import {
  DigitalMonthlyReportSidebar,
  DigitalMonthlyReportTab,
} from './DigitalMonthlyReportSidebar';

type DigitalMonthlyReportTemplateProps = {
  selectedTab: DigitalMonthlyReportTab;
  setSelectedTab: React.Dispatch<React.SetStateAction<DigitalMonthlyReportTab>>;
  hasMonthlyStatements: boolean;
  portfolioCovenantKeys: string[] | null;
  financialCovenantKeys: string[] | null;
  borrowingBaseReportId: string | null;
  children: React.ReactNode;
};
export const DigitalMonthlyReportTemplate = ({
  selectedTab,
  setSelectedTab,
  hasMonthlyStatements,
  portfolioCovenantKeys,
  financialCovenantKeys,
  borrowingBaseReportId,
  children,
}: DigitalMonthlyReportTemplateProps) => {
  return (
    <Box>
      <Grid templateColumns="repeat(6, 1fr)">
        <GridItem colSpan={1}>
          <DigitalMonthlyReportSidebar
            selectedTab={selectedTab}
            setSelectedTab={setSelectedTab}
            financialCovenantKeys={financialCovenantKeys}
            portfolioCovenantKeys={portfolioCovenantKeys}
            borrowingBaseReportId={borrowingBaseReportId}
            hasMonthlyStatements={hasMonthlyStatements}
          />
        </GridItem>
        <GridItem colSpan={5} pl="40px">
          {children}
        </GridItem>
      </Grid>
    </Box>
  );
};
